import { render } from "./ChromeMusicLab.vue?vue&type=template&id=4535915a&scoped=true"
import script from "./ChromeMusicLab.vue?vue&type=script&lang=js"
export * from "./ChromeMusicLab.vue?vue&type=script&lang=js"

import "./ChromeMusicLab.vue?vue&type=style&index=0&id=4535915a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4535915a"]])

export default __exports__